import React, { useContext, useEffect, useState } from "react";
import UserProgress from "../../classes/UserProgress";
import GroupProgressCard from "./GroupProgressCard";
import GroupProgressCardDemo from "./GroupProgressCardDemo";
import { fetchUserGroups } from "../../services/firebase";
import { GlobalContext } from "../../contexts/GlobalContext";
import { snackBarConfigType } from "../../classes/SnackBarConfig";
import CustomSnackbar from "./CustomSnackbar";
import Add01Icon from "../../assets/icons/add-01-solid-standard";
import { useNavigate } from "react-router-dom";

interface GroupProgressListViewProps {
  userProgress: UserProgress[];
}

const GroupProgressListView: React.FC<GroupProgressListViewProps> = ({
  userProgress,
}) => {
  const navigate = useNavigate();

  const getUserProgressTier = () => {
    return {
      name: "Bronze",
      level: "1",
    };
  };

  const UserGroups = [
    {
      cardTitle: "Home",
      membersProgress: [
        {
          member_id: "A1",
          progressFrom: { book: "Al-Baqarah", chapter: 2, verse: 1 },
          progressTo: { book: "Al-Baqarah", chapter: 2, verse: 20 },
          status: 1, // or "Completed"
          created_at: 1680000000, // Example timestamp
          member_name: "Aisha",
          group_id: "GroupA",
        },
        {
          member_id: "A2",
          progressFrom: { book: "Al-Baqarah", chapter: 2, verse: 1 },
          progressTo: { book: "Al-Baqarah", chapter: 2, verse: 15 },
          status: 0, // or "In Progress"
          created_at: 1680100000,
          member_name: "Bilal",
          group_id: "GroupA",
        },
        {
          member_id: "A3",
          progressFrom: { book: "Al-Baqarah", chapter: 2, verse: 1 },
          progressTo: { book: "Al-Baqarah", chapter: 2, verse: 30 },
          status: 1,
          created_at: 1680200000,
          member_name: "Fatima",
          group_id: "GroupA",
        },
        {
          member_id: "A4",
          progressFrom: { book: "Al-Baqarah", chapter: 2, verse: 10 },
          progressTo: { book: "Al-Baqarah", chapter: 2, verse: 35 },
          status: 0,
          created_at: 1680300000,
          member_name: "Omar",
          group_id: "GroupA",
        },
      ],
    },
    {
      cardTitle: "Friends",
      membersProgress: [
        {
          member_id: "B1",
          progressFrom: { book: "Al-Imran", chapter: 3, verse: 1 },
          progressTo: { book: "Al-Imran", chapter: 3, verse: 10 },
          status: 1,
          created_at: 1680400000,
          member_name: "Khadija",
          group_id: "GroupB",
        },
        {
          member_id: "B2",
          progressFrom: { book: "Al-Imran", chapter: 3, verse: 1 },
          progressTo: { book: "Al-Imran", chapter: 3, verse: 5 },
          status: 0,
          created_at: 1680500000,
          member_name: "Yusuf",
          group_id: "GroupB",
        },
        {
          member_id: "B3",
          progressFrom: { book: "An-Nisa", chapter: 4, verse: 1 },
          progressTo: { book: "An-Nisa", chapter: 4, verse: 20 },
          status: 1,
          created_at: 1680600000,
          member_name: "Maryam",
          group_id: "GroupB",
        },
        {
          member_id: "B4",
          progressFrom: { book: "An-Nisa", chapter: 4, verse: 10 },
          progressTo: { book: "An-Nisa", chapter: 4, verse: 30 },
          status: 0,
          created_at: 1680700000,
          member_name: "Ali",
          group_id: "GroupB",
        },
        {
          member_id: "B5",
          progressFrom: { book: "An-Nisa", chapter: 4, verse: 20 },
          progressTo: { book: "An-Nisa", chapter: 4, verse: 40 },
          status: 1,
          created_at: 1680800000,
          member_name: "Safiya",
          group_id: "GroupB",
        },
      ],
    },
    {
      cardTitle: "Tafsir Group",
      membersProgress: [
        {
          member_id: "C1",
          progressFrom: { book: "Al-Ma'idah", chapter: 5, verse: 1 },
          progressTo: { book: "Al-Ma'idah", chapter: 5, verse: 15 },
          status: 1,
          created_at: 1680900000,
          member_name: "Ibrahim",
          group_id: "GroupC",
        },
        {
          member_id: "C2",
          progressFrom: { book: "Al-Ma'idah", chapter: 5, verse: 5 },
          progressTo: { book: "Al-Ma'idah", chapter: 5, verse: 25 },
          status: 0,
          created_at: 1681000000,
          member_name: "Hafsa",
          group_id: "GroupC",
        },
      ],
    },
  ];

  const { currentUser, getCurrentUser } = useContext(GlobalContext);
  const [groups, setGroups] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  let [snackBarConfig, setSnackBarConfig] = useState<snackBarConfigType>({
    open: false,
    severity: "success",
    message: "",
  });

  useEffect(() => {
    const loadGroups = async () => {
      if (!currentUser?.id) return;
      setLoading(true);

      try {
        const fetchedGroups = await fetchUserGroups(currentUser.id);
        setGroups(fetchedGroups);
      } catch (error) {
        setSnackBarConfig({
          open: true,
          severity: "error",
          message: "Failed to load groups.",
        });
      }
      setLoading(false);
    };

    loadGroups();
  }, [currentUser?.id]);

  return (
    <>
      <CustomSnackbar snackbarConfig={snackBarConfig} />

      <div className="flex flex-col justify-center items-center my-8">
        <div className="w-full flex flex-col justify-center items-center my-8">
          <h2 className="font-grgrifter text-[2.2rem] tracking-wider text-[#AFAEB3]">
            {/* <h2 className="font-grgrifter text-[2.8rem] tracking-wider text-[#AFAEB3] mb-4"> */}
            Group Progress
          </h2>
          {groups.length === 0 && (
            <div className="w-[20em]  px-6 py-3  flex flex-col items-center justify-center text-center">
              <p>This is how group progress will look once its live 🚀</p>
            </div>
          )}
          <button
            className="flex items-center justify-center px-4 py-3 bg-[#3A9437] rounded-[2em] cursor-pointer mt-4"
            type="submit"
            onClick={() => navigate("/group")}
          >
            <Add01Icon size={18} className="mr-2" color="#FFF" />
            <p className="text-sm tracking-wider text-left text-white">
              Create New Group
            </p>
          </button>
        </div>

        <div className="w-full flex flex-col gap-4 my-2">
          {groups.length > 0
            ? groups.map((group) => (
                <GroupProgressCard
                  key={group.id}
                  cardTitle={group.name}
                  memberIds={group.members}
                />
              ))
            : UserGroups.map((group, index) => (
                <GroupProgressCardDemo
                  key={index}
                  cardTitle={group.cardTitle}
                  membersProgress={group.membersProgress}
                />
              ))}
        </div>
      </div>
    </>
  );
};

export default GroupProgressListView;
